<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 20:14:44
 * @LastEditTime: 2019-06-26 20:14:44
 * @LastEditors: your name
 -->
<template>
  <div class="container">
       <div class="pageTitle">库存统计(统计非实时统计,更新截至前一天)</div>

    <el-tabs v-model="active" type="card">
      <el-tab-pane label="我的库存统计" name="1">
        <my />
      </el-tab-pane>
      <el-tab-pane label="出货统计" name="2">
        <out />
      </el-tab-pane>
      <el-tab-pane label="下级经销商统计" name="3">



        <next/>





      </el-tab-pane>
      <el-tab-pane label="门店库存统计" name="4">

        <store/>




      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import my from './components/my.vue'
import out from './components/out.vue'
import next from './components/next.vue'
import store from './components/store.vue'

export default {
  name: "",
  data() {
    return {
      active: "1",
      form1: {
        product_sn: "",
        product_name: "",
        role: "",
        isgift: "",
        start_time: "",
        end_time: ""
      }
    };
  },
  components:{
my,out,next,store
  }
};
</script>



<style lang="scss" scoped>
</style>
